import React, { Component } from 'react'

import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Button from '@material-ui/core/Button'

/**
 * Диалог вывода сообщения об удачном восстановлении пароля.
 * 
 * onCloseClick()
 */

class SuccessRestorePasswordDialog extends Component {

	render() {

		return <Dialog
			open
			scroll = "body"
		>

			<DialogTitle>Пароль восстановлен</DialogTitle>

			<DialogContent style = {{display: "flex", flexDirection: "column"}}>
				Ваши регистрационные данные высланы на указанные вами email.
			</DialogContent>

			<DialogActions>

				<Button
					onClick={
						e => {
							e.preventDefault()
							if (typeof this.props.onCloseClick === "function") {
								this.props.onCloseClick()
							}
						}
					}
				>Закрыть</Button>

			</DialogActions>

		</Dialog>

	}

}

export default SuccessRestorePasswordDialog
